import { render } from "./NewProjectsContent.vue?vue&type=template&id=e1ef6080&scoped=true"
const script = {}

import "./NewProjectsContent.vue?vue&type=style&index=0&id=e1ef6080&scoped=true&lang=scss"

import exportComponent from "/Users/gisselareyes/Documents/Github/gisse-la/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1ef6080"]])

export default __exports__